import PropTypes from 'prop-types';
import { Overlay } from '@eti/components';
import { FareRule } from '@eti/types';
import FareRulesDrawerContent from '../../../../order-details/components/common/FareRulesDrawerContent';

const FareRulesOverlay = ({
  isOpen,
  onClose,
  fareRulesHeaderText,
  fareRules,
  fareRulesDescription,
}) => (
  <Overlay.Drawer dataTestId="fareRules-overlay" handleClose={onClose} isOpen={isOpen}>
    <Overlay.Header onClose={onClose} title={fareRulesHeaderText} />
    <Overlay.Content data-testid="fareRules-overlay-content">
      <FareRulesDrawerContent fareRules={fareRules} fareRulesDescription={fareRulesDescription} />
    </Overlay.Content>
  </Overlay.Drawer>
);

FareRulesOverlay.propTypes = {
  fareRules: PropTypes.arrayOf(FareRule),
  fareRulesDescription: PropTypes.string,
  fareRulesHeaderText: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default FareRulesOverlay;
